<template>
  <button
    v-show="showButton"
    @click="scrollToTop"
    class="scroll-to-top"
    :class="{ visible: showButton }"
    aria-label="Volver al inicio"
  >
    <svg
      class="chevron-up"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15L12 9L6 15"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const showButton = ref(false)

const handleScroll = () => {
  showButton.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: linear-gradient(45deg, #1297ef, #4ab7ff);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(18, 151, 239, 0.3);
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
  z-index: 1000;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.scroll-to-top.visible {
  opacity: 1;
  transform: translateY(0);
}

.scroll-to-top:hover {
  background: linear-gradient(45deg, #0d5fef, #49bbff);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(18, 151, 239, 0.4);
}

.scroll-to-top:active {
  transform: translateY(-1px);
}

.chevron-up {
  transition: transform 0.3s ease;
  pointer-events: none;
}

.scroll-to-top:hover .chevron-up {
  transform: translateY(-2px);
}

/* Responsive */
@media (max-width: 768px) {
  .scroll-to-top {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 480px) {
  .scroll-to-top {
    bottom: 15px;
    right: 15px;
    width: 40px;
    height: 40px;
  }

  .chevron-up {
    width: 20px;
    height: 20px;
  }
}
</style>
